<template>
  <header class="container-fluid text-end py-1 border-bottom">
    <div>
      <span class="font-monospace">{{ walletAddress }}</span>
    </div>
    <div>
      <span class="text-primary cursor-pointer" @click="connectWallet()">Connect Wallet</span>
    </div>
  </header>
</template>

<style scoped>

</style>

<script setup lang="ts">
import { ref, reactive, computed, onMounted } from "vue";
import { useOnboard } from "@web3-onboard/vue";
import { walletAddress, chainId } from "@/services/onboard.ts";
import { wallets } from "@/services/eip6963";

const { connectWallet, connectedWallet, disconnectConnectedWallet } = useOnboard();
</script>

